import {REQUESTS_URL} from './constants';


const makeRequest = async (url, method = 'GET', body = null) => {
    let workOnUrl, headers;

    if (url.startsWith("http://") || url.startsWith("https://")) {
        workOnUrl = url;
    } else {
        workOnUrl = `${REQUESTS_URL}/${url}`;
    }

    if (typeof body === "string") {
        headers = {
            'Content-Type': 'application/json'
        }
    } else {
        headers = {};
    }

    const response = await fetch(
        workOnUrl,
        {
            method: method,
            body: body,
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: headers,
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
        }
    )
    const {ok, msg, obj} = await response.json();
    return {ok, msg, obj};
}

export {makeRequest};
